import React from 'react';

/**
 * Renderiza el bloque ComparisonCanvas de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function ComparisonCanvas({
  v
}) {
  return v.cNotSup ? React.createElement(React.Fragment, null, v.text("\n        "), v.cFocOn ? React.createElement(React.Fragment, null, v.text("\n          "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh",
      "padding": "0.740741vh 1.111111vh",
      "borderRadius": "0.740741vh",
      "background": "rgba(232,80,15,0.08)",
      "border": "0.092593vh solid rgba(232,80,15,0.45)"
    }
  }, v.text("\n            "), React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "50%",
      "background": "#E8500F",
      "flex": "none"
    }
  }, null), v.text("\n            "), React.createElement("span", {
    style: {
      "fontSize": "1.203704vh",
      "color": "#e4e9f0",
      "whiteSpace": "nowrap"
    }
  }, v.text("Día enfocado "), React.createElement("span", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": "#E8500F"
    }
  }, v.text(v.cFocLab))), v.text("\n            "), React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(v.cFocSum)), v.text("\n            "), React.createElement("span", {
    style: {
      "marginLeft": "auto",
      "display": "flex",
      "gap": "0.740741vh",
      "flex": "none"
    }
  }, v.text("\n              "), React.createElement("button", {
    "onClick": v.cFocPrev,
    style: {
      "background": "rgba(20,38,62,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.277778vh 0.833333vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("‹")), v.text("\n              "), React.createElement("button", {
    "onClick": v.cFocNext,
    style: {
      "background": "rgba(20,38,62,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.277778vh 0.833333vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("›")), v.text("\n              "), React.createElement("button", {
    "onClick": v.cFocOpen,
    style: {
      "background": "rgba(232,80,15,0.15)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.277778vh 0.833333vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "borderColor": "#E8500F"
    }
  }, v.text("Abrir en panel ›")), v.text("\n              "), React.createElement("button", {
    "onClick": v.cFocClear,
    style: {
      "background": "transparent",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#b8c1ce",
      "borderRadius": "0.555556vh",
      "padding": "0.277778vh 0.833333vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Quitar enfoque ✕")), v.text("\n            ")), v.text("\n          ")), v.text("\n        ")) : null, v.text("\n        "), React.createElement("div", {
    style: {
      "position": "relative"
    }
  }, v.text("\n          "), React.createElement("canvas", {
    "data-cmp-canvas": "1",
    "width": "1460",
    "height": "800",
    "onWheel": v.cWheel,
    "onContextMenu": v.cNoMenu,
    "onMouseDown": v.cDown,
    "onMouseMove": v.cDragH,
    "onMouseUp": v.cUp,
    "onMouseLeave": v.cOut,
    style: {
      "width": "100%",
      "height": "74.074074vh",
      "display": "block",
      "cursor": v.cCursor
    }
  }, null), v.text("\n          "), React.createElement("div", {
    style: {
      "position": "absolute",
      "left": v.ctX,
      "top": v.ctY,
      "transform": v.ctTx,
      "minWidth": "11.458333vw",
      "maxWidth": "13.541667vw",
      "background": "rgba(4,10,20,0.96)",
      "border": "0.092593vh solid " + v.ctBd,
      "borderRadius": "0.740741vh",
      "padding": "0.740741vh 1.111111vh",
      "display": v.ctD,
      "flexDirection": "column",
      "gap": "0.37037vh",
      "pointerEvents": "none",
      "zIndex": "4",
      "boxShadow": "0 0.740741vh 2.222222vh rgba(0,0,0,0.5)"
    }
  }, v.text("\n            "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "1.111111vh",
      "alignItems": "baseline"
    }
  }, React.createElement("span", {
    style: {
      "font": "500 1.203704vh 'IBM Plex Mono',monospace"
    }
  }, v.text(v.ctT)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": v.ctAlC
    }
  }, v.text(v.ctAl))), v.text("\n            "), (v.ctRows || []).map((r, index164) => React.createElement(React.Fragment, {
    key: index164
  }, v.text("\n              "), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "1.481481vh",
      "fontSize": "1.111111vh",
      "fontWeight": r.fw
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "color": r.lc
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": r.c
    }
  }, null), v.text(r.lab)), React.createElement("span", {
    style: {
      "fontFamily": "'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(r.val))), v.text("\n            "))), v.text("\n            "), React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)",
      "paddingTop": "0.37037vh"
    }
  }, v.text(v.ctFoot)), v.text("\n          ")), v.text("\n        ")), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh",
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text("\n          \n          "), React.createElement("span", {
    style: {
      "marginLeft": "auto"
    }
  }, null), v.text("\n          "), v.cIs3d ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, React.createElement("button", {
    "onClick": v.cZoomOut,
    style: {
      "border": "0",
      "background": "transparent",
      "color": "#e4e9f0",
      "cursor": "pointer",
      "font": "1.296296vh 'IBM Plex Sans',sans-serif",
      "padding": "0.185185vh 0.925926vh"
    }
  }, v.text("−")), React.createElement("span", {
    style: {
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce",
      "minWidth": "2.5vw",
      "textAlign": "center"
    }
  }, v.text(v.cZoomTxt)), React.createElement("button", {
    "onClick": v.cZoomIn,
    style: {
      "border": "0",
      "background": "transparent",
      "color": "#e4e9f0",
      "cursor": "pointer",
      "font": "1.296296vh 'IBM Plex Sans',sans-serif",
      "padding": "0.185185vh 0.925926vh"
    }
  }, v.text("+")))) : null, v.text("\n          "), v.cIs3d ? React.createElement(React.Fragment, null, React.createElement("button", {
    "onClick": v.cReset,
    style: {
      "background": "rgba(20,38,62,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.18)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif"
    }
  }, v.text("Restablecer vista"))) : null, v.text("\n        ")), v.text("\n      ")) : null;
}
